export default __webpack_public_path__ + "static/media/Widowdusk Hood.f7ebb7fa.jpg";